<template>
  <div>
    <div
      class="mb-5 rounded border-l-4 border-red-500 bg-red-100 p-4 text-orange-700"
      role="alert"
    >
      <p class="font-bold">
        Oops!
      </p>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationComponent',

  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>
